<template>
  <div id="contenedor-listado-configuracion-firmas">
    <template
      v-if="!$vuetify.breakpoint.mobile">
      <desktop
        :listado="listado">
      </desktop>
    </template>
    <template
      v-else>
      <mobile></mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoConfiguracionFirmas',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
